module.exports = __webpack_public_path__ + "static/media/herd-freed-hartz.d2790b82.svg";